import GenericView from 'js/views/generic.view';
import CreditsSpentCollection from 'js/models/credits.spent.paginated.collection';
import PaginatedView from 'js/views/pagination.view';
import Template from 'js/templates/credits.spent.hbs';
import {debounce, el, on, template} from "../adapters/backbone-decorators";

require('jqueryUI');
require('metroHelpers');

@el('#credit-spent-container')
@template(Template)
class CreditsSpentView extends GenericView {

    constructor() {
        super();
        this.textFilter = "";
        this.collection = new CreditsSpentCollection();
        this.collection.on('sync', this.renderCollection, this);
        this.loadCreditsSpent();
    }

    render() {
        super.render();
    }

    renderCollection() {
        const tempTemplate = this.template({
            collection: this.collection.data
        });
        this.$el.html(tempTemplate);
        const $searchbox = this.$el.find('.searchbox');
        $searchbox.val(this.textFilter);
        $searchbox.focus();
        this.$('[data-i18n]').i18n();
        if (this.pagination) {
            this.pagination.remove();
        }
        this.pagination = new PaginatedView({collection: this.collection});
        this.pagination.render();
        this.$('#pagination').html(this.pagination.$el);
    }

    loadCreditsSpent() {
        this.collection.getFirstPage();
    }

    @debounce(800)
    @on('keyup .searchbox')
    searchByFilter(event) {
        const value = event.currentTarget.value;
        this.textFilter = value;
        if (value) {
            this.collection.url = `/CampaignCloud/CreditsController/CreditSpent?filter=${this.textFilter}`;
        } else {
            this.collection.url = '/CampaignCloud/CreditsController/CreditSpent';
        }
        this.collection.getFirstPage();
    }
}

export default CreditsSpentView;
